export const ships = [
  { type: 'Carrier', length: 5 },
  { type: 'Battleship', length: 4 },
  { type: 'Cruiser', length: 3 },
  { type: 'Submarine', length: 3 },
  { type: 'Destroyer', length: 2 }
]
